import { z } from 'zod';

export const CreateOrganizationSecretRequestBodySchema = z.object({
  secretValue: z.string(),
  secretDescription: z.string(),
});

export type CreateOrganizationSecretRequestBodyType = z.infer<
  typeof CreateOrganizationSecretRequestBodySchema
>;

export const UpdateOrganizationSecretRequestBodySchema = z.object({
  secretValue: z.string().nullable(),
  secretDescription: z.string(),
});

export type UpdateOrganizationSecretRequestBodyType = z.infer<
  typeof UpdateOrganizationSecretRequestBodySchema
>;
